export enum PlannerItemModelTypeEnum {
  task = 'task',
  event = 'event',
  payment = 'payment',
  todo = 'todo',
  note = 'note',
}
